export default "__VITE_ASSET__Ct_Ej$B0__"